// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GeneralView" + "." + "794b7f437f211b5cafbe" + ".js";
};